module.exports = require('../dist/compat/math/minBy.js').minBy;
